/* eslint-disable max-len */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const SuccessTick = ({ width, height, title, ...others }) => (
  <SvgIcon
    style={{
      width: width || '16px',
      height: height || '16px',
    }}
    viewBox="0 0 80 80"
    fill="none"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...others}
  >
    <title>{title}</title>
    <circle cx="40" cy="40" r="40" fill="#E6F8F9" />
    <path
      d="M32.7448 55.5729L19.4427 42.2708C17.8802 40.7083 17.8802 38.1771 19.4427 36.6146L20.8594 35.2031C22.4219 33.6406 24.9532 33.6406 26.5157 35.2031L36 44.6875L55.4844 25.2031C57.0469 23.6406 59.5782 23.6406 61.1407 25.2031L62.5573 26.6146C63.5261 27.5833 63.8959 28.9271 63.6615 30.1823C63.5157 30.9479 62.1459 31.6823 61.5573 32.2708L39.2552 54.5729C38.3542 55.474 37.1771 56.9219 36 56.9219C34.823 56.9219 33.6459 56.474 32.7448 55.5729Z"
      fill="#80DBE0"
    />
    <path
      d="M36 56.9219C35.4479 56.9219 35 56.474 35 55.9219C35 55.3698 35.4479 54.9219 36 54.9219C36.6927 54.9219 37.349 54.651 37.8385 54.1615L61.1406 30.8594C61.4271 30.5729 61.6198 30.2135 61.6927 29.8125C61.7969 29.2708 62.3229 28.9219 62.8594 29.0156C63.401 29.1146 63.7604 29.6406 63.6615 30.1823C63.5104 30.974 63.1302 31.6979 62.5573 32.2708L39.2552 55.5729C38.3854 56.4427 37.2292 56.9219 36 56.9219Z"
      fill="#1B3642"
    />
  </SvgIcon>
);

export default SuccessTick;
